import {
  Bar,
  BarChart,
  CartesianGrid,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip as RTooltip,
  XAxis,
  YAxis,
} from 'recharts';
import type { BaselineSeriesPoint } from '@halo/web-types';
import { ChartTooltip } from './ChartTooltip';

export function HaloSplitChart({ points }: { points: BaselineSeriesPoint[] }) {
  return (
    <div className="rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
      <h2 className="text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
        Daily halo split (positive halo / negative residual)
      </h2>
      <ResponsiveContainer width="100%" height={140}>
        <BarChart data={points} barCategoryGap="20%">
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" vertical={false} />
          <XAxis
            dataKey="date"
            tick={{ fontSize: 10, fill: '#9ca3af' }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tickFormatter={(v: number) => `$${(v / 1000).toFixed(1)}k`}
            tick={{ fontSize: 10, fill: '#9ca3af' }}
            axisLine={false}
            tickLine={false}
            width={52}
          />
          <ReferenceLine y={0} stroke="#d1d5db" />
          <RTooltip content={<ChartTooltip formatValue={(v) => `$${v.toLocaleString()}`} />} />
          <Bar
            dataKey="positiveHalo"
            name="positive halo"
            fill="#16a34a"
            stackId="split"
            isAnimationActive={false}
          />
          <Bar
            dataKey="negativeResidual"
            name="negative residual"
            fill="#dc2626"
            stackId="split"
            isAnimationActive={false}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
